/**
 * Get currently selected module
 * Endpoint: GET /users/selected-module
 * Returns: 200 with module data, or 204 No Content if no selection
 */

import type { AxiosError } from 'axios';

import { axiosInstance } from '@configs/axios/axiosInstance';

import type { SelectedModule } from '../types/module.types';

export async function fetchSelectedModule(): Promise<SelectedModule | null> {
  try {
    const { data } = await axiosInstance.get<SelectedModule>(
      '/users/selected-module'
    );
    return data;
  } catch (error) {
    // 204 No Content means no selected module
    if ((error as AxiosError).response?.status === 204) {
      return null;
    }
    throw error;
  }
}
